import { ChangeableModel } from "../../../model/model";
import { IMriPrescreeningState } from "./MriPrescreeningState";


export class MriPrescreeningModel extends ChangeableModel<IMriPrescreeningState> {
}